import { render, staticRenderFns } from "./RideDescription.vue?vue&type=template&id=680e2036"
import script from "./RideDescription.vue?vue&type=script&lang=js"
export * from "./RideDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports